/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Team_Manager_Owner_Cannot_DisableInputs */



/**
* | output |
* | --- |
* | "User ({email}) is the team owner and can not be disabled." |
*
* @param {Team_Manager_Owner_Cannot_DisableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_owner_cannot_disable = /** @type {((inputs: Team_Manager_Owner_Cannot_DisableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Owner_Cannot_DisableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L’utilisateur (${i?.email}) est le propriétaire de l’équipe et ne peut pas être désactivé.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Benutzer (${i?.email}) ist der Teambesitzer und kann nicht deaktiviert werden.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'utente (${i?.email}) è il proprietario del team e non può essere disabilitato.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Пользователь (${i?.email}) является владельцем команды и не может быть отключен.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El usuario (${i?.email}) es el propietario del equipo y no se puede deshabilitar.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`用户（${i?.email}）是团队所有者，无法禁用。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ユーザー (${i?.email}) はチーム所有者であり、無効にすることはできません。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपयोगकर्ता (${i?.email}) टीम का स्वामी है और उसे निष्क्रिय नहीं किया जा सकता है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O usuário (${i?.email}) é o proprietário da equipe e não pode ser desativado.`)
	return /** @type {LocalizedString} */ (`User (${i?.email}) is the team owner and can not be disabled.`)
});